module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-home-wrap",
    attrs: {
      "id": "jsTargetTop"
    }
  }, [_c('section', {
    ref: "section1",
    staticClass: "p-home-section"
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isLoaded ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section1
    }
  }), _vm._m(0), _c('div', {
    staticClass: "p-home-section__btn-next",
    on: {
      "click": function($event) {
        return _vm.handleMove("#jsTargetAbout")
      }
    }
  }, [_c('div', {
    staticClass: "p-home-section__label-next"
  }, [_vm._v("寄り道する")]), _c('md-icon', {
    staticClass: "md-size-4x p-home-section__icon-next"
  }, [_vm._v("keyboard_arrow_down")])], 1)]), _c('section', {
    ref: "section2",
    staticClass: "p-home-section is-white",
    attrs: {
      "id": "jsTargetAbout"
    }
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isOver.section2 ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section2
    }
  }), _vm._m(1)]), _c('section', {
    ref: "section3",
    staticClass: "p-home-section",
    attrs: {
      "id": "jsTargetShop"
    }
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isOver.section3 ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section3
    }
  }), _c('div', {
    staticClass: "p-home-section__content--shop"
  }, [_c('h3', {
    staticClass: "p-home-section__title"
  }, [_vm._v("おみやげ")]), _vm._m(2), _c('div', {
    staticClass: "p-home-section__slider"
  }, [_c('md-boards', {
    staticClass: "md-transparent",
    attrs: {
      "md-controls": true,
      "md-swipeable": true
    }
  }, _vm._l((_vm.shopItems), function(item, index) {
    return _c('md-board', {
      key: item.url,
      staticClass: "p-home-shop__wrap",
      attrs: {
        "id": "item_" + index
      }
    }, [_c('div', {
      staticClass: "p-home-shop__inner"
    }, [_c('div', {
      staticClass: "p-home-shop__capture"
    }, [_c('img', {
      staticClass: "p-home-shop__img",
      attrs: {
        "src": item.img
      }
    })]), _c('div', {
      staticClass: "p-home-shop__content"
    }, [_c('p', {
      staticClass: "p-home-shop__title u-elps-1"
    }, [_vm._v(_vm._s(item.name))]), _c('md-button', {
      staticClass: "p-home-shop__btn md-raised md-accent",
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_vm._v("お取り寄せする")])], 1)])])
  }), 1)], 1), _vm._m(3)])]), _c('section', {
    ref: "section5",
    staticClass: "p-home-section",
    attrs: {
      "id": "jsTargetCompany"
    }
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isOver.section5 ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section5
    }
  }), _c('div', {
    staticClass: "p-home-section__content"
  }, [_c('h3', {
    staticClass: "p-home-section__title"
  }, [_vm._v("会社概要")]), _c('div', {
    staticClass: "p-home-section__desc"
  }, [_c('md-list', {
    staticClass: "md-double-line"
  }, [_c('md-list-item', [_c('md-icon', [_vm._v("store")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("店名")]), _c('div', [_vm._v("佐藤物産館")])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("domain")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("会社名")]), _c('div', [_vm._v("株式会社 佐藤物産")])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("place")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("住所")]), _c('div', [_vm._v("〒964-0074"), _c('br'), _vm._v("福島県二本松市岳温泉一丁目14番地")])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("phone")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("TEL")]), _c('div', [_vm._v("0243-24-2504")])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("print")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("FAX")]), _c('span', [_vm._v("0243-24-2266")])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("email")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("EMAIL")]), _c('span', [_vm._v(_vm._s(_vm.config.contact.to))])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("face")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("代表取締役")]), _c('span', [_vm._v("佐藤はるみ")])])], 1)], 1)], 1)])]), _c('section', {
    ref: "section6",
    staticClass: "p-home-section is-white",
    attrs: {
      "id": "jsTargetAccess"
    }
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isOver.section6 ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section6
    }
  }), _c('div', {
    staticClass: "p-home-section__content"
  }, [_c('h3', {
    staticClass: "p-home-section__title"
  }, [_vm._v("アクセス")]), _c('div', {
    staticClass: "p-home-section__desc"
  }, [_c('div', {
    staticClass: "p-home-map-frame"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "center": _vm.config.map.center,
      "zoom": 18,
      "map-type-id": _vm.config.map.type,
      "options": _vm.config.map.options
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.config.map.maker.pos,
      "clickable": true,
      "draggable": true
    },
    on: {
      "click": function($event) {
        _vm.center = _vm.config.map.maker.pos
      }
    }
  })], 1)], 1)])])]), _c('section', {
    ref: "section7",
    staticClass: "p-home-section",
    attrs: {
      "id": "jsTargetContact"
    }
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isOver.section7 ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section7
    }
  }), _c('div', {
    staticClass: "p-home-section__content"
  }, [_c('h3', {
    staticClass: "p-home-section__title"
  }, [_vm._v("お問い合わせ")]), _c('div', {
    staticClass: "p-home-section__desc"
  }, [_c('form', {
    staticClass: "p-home-contact md-theme-default md-list",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-home-contact__type-wrap"
  }, [_c('div', {
    staticClass: "p-home-contact__label"
  }, [_vm._v("お問い合わせ種別")]), _c('div', {
    staticClass: "p-home-contact__type-list"
  }, _vm._l((_vm.config.contact.types), function(typeItem, index) {
    return _c('md-radio', {
      key: typeItem.id,
      staticClass: "p-home-contact__type-item md-primary",
      attrs: {
        "name": "type",
        "id": typeItem.id,
        "md-value": typeItem.id
      },
      model: {
        value: (_vm.contact.type.value),
        callback: function($$v) {
          _vm.$set(_vm.contact.type, "value", $$v)
        },
        expression: "contact.type.value"
      }
    }, [_vm._v(_vm._s(typeItem.label))])
  }), 1)]), _c('md-input-container', {
    staticClass: "p-home-contact__email-wrap",
    class: (_vm.contact.email.invalid.format || _vm.contact.email.invalid.require) ? "md-input-invalid" : "",
    attrs: {
      "md-clearable": "md-clearable"
    }
  }, [_c('label', [_vm._v("ご連絡先メールアドレス")]), _c('md-input', {
    attrs: {
      "required": "required"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.handleEmailValid()
      }
    },
    model: {
      value: (_vm.contact.email.value),
      callback: function($$v) {
        _vm.$set(_vm.contact.email, "value", $$v)
      },
      expression: "contact.email.value"
    }
  }), _c('ul', {
    staticClass: "p-home-contact__invalid-list"
  }, [(_vm.contact.email.invalid.format) ? _c('li', {
    staticClass: "p-home-contact__invalid-item md-error"
  }, [_vm._v("メールアドレスの形式が不正です。")]) : _vm._e(), (_vm.contact.email.invalid.require) ? _c('li', {
    staticClass: "p-home-contact__invalid-item md-error"
  }, [_vm._v("メールアドレスが入力されていません。")]) : _vm._e()])], 1), _c('md-input-container', {
    staticClass: "p-home-contact__content-wrap",
    class: _vm.contact.content.invalid.require ? "md-input-invalid" : "",
    attrs: {
      "md-clearable": "md-clearable"
    }
  }, [_c('label', [_vm._v("お問い合わせ内容")]), _c('md-textarea', {
    attrs: {
      "required": "required"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.handleContentValid()
      }
    },
    model: {
      value: (_vm.contact.content.value),
      callback: function($$v) {
        _vm.$set(_vm.contact.content, "value", $$v)
      },
      expression: "contact.content.value"
    }
  }), _c('ul', {
    staticClass: "p-home-contact__invalid-list"
  }, [(_vm.contact.content.invalid.require) ? _c('li', {
    staticClass: "p-home-contact__invalid-item md-error"
  }, [_vm._v("お問い合わせ内容が入力されていません。")]) : _vm._e()])], 1), _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "href": _vm.mailTo
    }
  }, [_vm._v("メールで送信する")])], 1)])])]), _c('md-button', {
    staticClass: "md-fab md-clean p-home-btn-top",
    class: _vm.btnTop.isShow ? "is-active" : "",
    on: {
      "click": function($event) {
        return _vm.handleMove("#jsTargetTop")
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-size-2x p-home-icon-top"
  }, [_vm._v("arrow_upward")])], 1), _c('md-snackbar', {
    ref: "snackbar",
    staticClass: "p-home-snackbar",
    attrs: {
      "md-position": "top right",
      "md-duration": "10000"
    }
  }, [_c('div', {
    staticClass: "p-home-snackbar__lead-list"
  }, _vm._l((_vm.alertMessages), function(message) {
    return _c('div', {
      staticClass: "p-home-snackbar__lead-item"
    }, [_vm._v(_vm._s(message))])
  }), 0), _c('md-button', {
    on: {
      "click": function($event) {
        return _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("閉じる")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-home-section__content--firstView"
  }, [_c('h3', {
    staticClass: "p-home-copy"
  }, [_c('div', {
    staticClass: "p-home-copy__title"
  }, [_c('span', {
    staticClass: "p-home-copy__sp-br"
  }, [_vm._v("『少しだけ、")]), _c('span', {
    staticClass: "p-home-copy__sp-br"
  }, [_vm._v("寄り道する。』")])]), _c('div', {
    staticClass: "p-home-copy__desc"
  }, [_vm._v("福島に来たら少しだけ寄り道していきませんか?"), _c('br'), _vm._v("アクティビティや温泉で一汗かいたら、冷たいビールやアイスクリーム。"), _c('br'), _vm._v("旅の合間にふらっとお立ち寄りください。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-home-section__content"
  }, [_c('h3', {
    staticClass: "p-home-section__title"
  }, [_vm._v("当店について")]), _c('p', {
    staticClass: "p-home-section__desc"
  }, [_vm._v("当店は百名山安達太良山の麓「二本松」で昭和30年に物産店として創業いたしました。"), _c('br'), _c('br'), _vm._v("現在は4代目当主となる店主が元料理人だったこともあり、\n食品加工、その製品の卸売もおこなっております。"), _c('br'), _c('br'), _vm._v("食感にこだわった「福島の温泉たまご とろんたま」。"), _c('br'), _vm._v("酪農が盛んな、あだたら高原でとれた牛乳と\n本場ヨーロッパのクラシックな製法でつくられた「あだたら山のミルクジャム」\nなどの製品を提供しております。"), _c('br'), _c('br'), _vm._v("また、修学旅行などの団体様向けへのスキー用品レンタル、\n登山用品等のアクティビティツールのレンタルも取り扱っております。"), _c('br'), _c('br'), _vm._v("「温故知新」の理念のもと"), _c('br'), _vm._v("その土地の 文化、人、技術、素材と共に歩む企業を目指しております。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-home-section__desc"
  }, [_vm._v("自社商品のほか、店主が厳選した福島のおみやげや地酒を取り揃えております。"), _c('br'), _c('br'), _vm._v("お土産のお取り寄せもご対応させていただいております。"), _c('br'), _vm._v("旅のお手荷物にならないよう、ご自宅からご注文いただけます。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-home-section__desc"
  }, [_vm._v("また、店内にはカフェスペースを常設しております。"), _c('br'), _vm._v("温泉たまごや自社商品を使用したメニューをお楽しみいただけます。"), _c('br'), _vm._v("登山の帰り道や日帰り温泉の後にも、ぜひお立寄りください。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52a40d54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/index.vue
// module id = 252
// module chunks = 1